// always import this pack so that the CSS necessary for color variables to work is generated.
// add it in the page head, after including the CSS
import customizeColors from '../src/js/customize-colors';
customizeColors(document.head.dataset);
